<template>
  <TextBlob headingSize="s">
    <!-- lets put our logo in the top right and have the client's name here in the heading below -->
    <template #heading> F.A.Q. </template>
    <template #text>
      <el-table :data="faq">
        <el-table-column prop="question" fixed label="Question" />
        <el-table-column prop="answer" label="Answer" />
      </el-table>
    </template>
  </TextBlob>
</template>

<script setup>
import TextBlob from "@/components/TextBlob.vue";

import { ref } from 'vue';

import faqData from '@/assets/faq_data.json';

const faq = ref(faqData);

</script>
<style>
.el-table .cell {
  word-break: normal !important;
}
</style>
